import { render, staticRenderFns } from "./QuickpaymentPlans.vue?vue&type=template&id=1dc5ba8e&scoped=true&"
import script from "./QuickpaymentPlans.vue?vue&type=script&lang=js&"
export * from "./QuickpaymentPlans.vue?vue&type=script&lang=js&"
import style0 from "./QuickpaymentPlans.vue?vue&type=style&index=0&id=1dc5ba8e&scoped=true&lang=css&"
import style1 from "./QuickpaymentPlans.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc5ba8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCol,VForm,VIcon,VRow,VTextField})
